const KEY_TOKEN = 'token';
const KEY_REFRESH_TOKEN = 'refreshToken';
const KEY_REFRESH_ENDPOINT = 'refreshEndpoint';
const KEY_CM_TOKEN = 'cmToken';
const KEY_CM_REFRESH_TOKEN = 'cmRefreshToken';

export const TokenStorage = {
  setSession(token: string, refreshToken: string | null, refreshEndpoint: string): void {
    try {
      localStorage.setItem(KEY_TOKEN, token);
      if (refreshToken) {
        localStorage.setItem(KEY_REFRESH_TOKEN, refreshToken);
      } else {
        localStorage.removeItem(KEY_REFRESH_TOKEN);
      }
      localStorage.setItem(KEY_REFRESH_ENDPOINT, refreshEndpoint);
    } catch (e) {
      console.error('TokenStorage.setSession failed', e);
    }
  },

  getToken(): string | null {
    try {
      return localStorage.getItem(KEY_TOKEN);
    } catch {
      return null;
    }
  },

  getRefreshToken(): string | null {
    try {
      return localStorage.getItem(KEY_REFRESH_TOKEN);
    } catch {
      return null;
    }
  },

  getRefreshEndpoint(): string | null {
    try {
      return localStorage.getItem(KEY_REFRESH_ENDPOINT);
    } catch {
      return null;
    }
  },

  updateAccessToken(token: string): void {
    try {
      localStorage.setItem(KEY_TOKEN, token);
    } catch (e) {
      console.error('TokenStorage.updateAccessToken failed', e);
    }
  },

  updateTokens(token: string, refreshToken: string | null): void {
    try {
      localStorage.setItem(KEY_TOKEN, token);
      if (refreshToken) {
        localStorage.setItem(KEY_REFRESH_TOKEN, refreshToken);
      } else {
        localStorage.removeItem(KEY_REFRESH_TOKEN);
      }
    } catch (e) {
      console.error('TokenStorage.updateTokens failed', e);
    }
  },

  clearSession(): void {
    try {
      localStorage.removeItem(KEY_TOKEN);
      localStorage.removeItem(KEY_REFRESH_TOKEN);
      localStorage.removeItem(KEY_REFRESH_ENDPOINT);
    } catch (e) {
      console.error('TokenStorage.clearSession failed', e);
    }
  },

  setCMSession(token: string, refreshToken: string | null): void {
    try {
      localStorage.setItem(KEY_CM_TOKEN, token);
      if (refreshToken) {
        localStorage.setItem(KEY_CM_REFRESH_TOKEN, refreshToken);
      } else {
        localStorage.removeItem(KEY_CM_REFRESH_TOKEN);
      }
    } catch (e) {
      console.error('TokenStorage.setCMSession failed', e);
    }
  },

  getCMToken(): string | null {
    try {
      return localStorage.getItem(KEY_CM_TOKEN);
    } catch {
      return null;
    }
  },

  getCMRefreshToken(): string | null {
    try {
      return localStorage.getItem(KEY_CM_REFRESH_TOKEN);
    } catch {
      return null;
    }
  },

  clearCMSession(): void {
    try {
      localStorage.removeItem(KEY_CM_TOKEN);
      localStorage.removeItem(KEY_CM_REFRESH_TOKEN);
    } catch (e) {
      console.error('TokenStorage.clearCMSession failed', e);
    }
  },
};
